import {
    SearchEPTEndChannel,
    SearchEPTMarkChannel,
    SearchEPTStartChannel,
} from '@tableau/microview-communication-service/lib/src/channelDefinitions/SearchEPTChannelDefinitions';

import { SearchEPTService } from '~src/omnibox/services/SearchEPTService';

export function startListening(): () => void {
    const unsubscribeSearchEPTEndChannel = startListeningToSearchEPTStartChannel();
    const unsubscribeSearchEPTMarkChannel = startListeningToSearchEPTEndChannel();
    const unsubscribeSearchEPTStartChannel = startListeningToSearchEPTMarkChannel();

    return () => {
        unsubscribeSearchEPTEndChannel();
        unsubscribeSearchEPTMarkChannel();
        unsubscribeSearchEPTStartChannel();
    };
}

function startListeningToSearchEPTStartChannel(): () => void {
    const channel = new SearchEPTStartChannel();
    const unsubscribe = channel.listen(request => {
        SearchEPTService.instance.start(request.type, request.key);
    });

    return () => {
        unsubscribe();
    };
}

function startListeningToSearchEPTEndChannel(): () => void {
    const channel = new SearchEPTEndChannel();
    const unsubscribe = channel.listen(request => {
        SearchEPTService.instance.end(request.type, request.key);
    });

    return () => {
        unsubscribe();
    };
}

function startListeningToSearchEPTMarkChannel(): () => void {
    const channel = new SearchEPTMarkChannel();
    const unsubscribe = channel.listen(request => {
        SearchEPTService.instance.mark(request.type, request.key, request.timestampType);
    });

    return () => {
        unsubscribe();
    };
}
